import { render, staticRenderFns } from "./ProductionCard.vue?vue&type=template&id=3b824ec4&"
import script from "./ProductionCard.vue?vue&type=script&lang=js&"
export * from "./ProductionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports